import { canEdit } from "../../rest/data";
import { Abbreviation, Language } from "../../rest/models";
import { useAppSelector } from "../../store/hooks";
import { InfoTrigger } from "../info_popup/InfoTrigger";
import { AbbreviationEditForm } from "./AbbreviationEditForm";
import { AbbreviationListRow } from "./AbbreviationListRow";
import { AbbreviationExplanations } from "./explanation";

export function AbbreviationLanguageListRow(props: Props)
{
    const loginState = useAppSelector((state) => state.login);

    const l = props.lang;
    const abbrs = props.abbrs;

    const _public = abbrs
        .filter(a => a.public)
        .map(a => a.text)
        .join(' ');

    const public2 = _public.length
        ? <fieldset>
            <b>Public abbreviations:</b>
            <InfoTrigger children={AbbreviationExplanations.publicObject}/>

            <div>{_public}</div>
        </fieldset>
        : <></>;

    const editableTableRows = abbrs
        .filter(a => canEdit(a, loginState))
        .map(a => <AbbreviationListRow key={a.key} lang={l} abbr={a}/>);

    const italicsNote = loginState.currentUser.is_staff
        ? <div><i>For administrators: Rows in italics are public.</i></div>
        : <></>;

    return (
    <fieldset className='ernots_TableWrapper'>
        <div>Create new abbreviation for <b>{l.name}</b></div>
        <AbbreviationEditForm lang={l} onDone={() => {}}/>
        <br/>
        
        <div>Abbreviations for <b>{l.name}</b></div>
        {italicsNote}
        <table className='ernots_ModelTable ernots_AbbreviationTable' border={1}>
            <thead>
                <tr>
                    <th>Text</th>
                    <th>Edit</th>
                    <th>Delete</th>
                </tr>
            </thead>
            <tbody>
                {editableTableRows}
            </tbody>
        </table>
        {public2}
    </fieldset>);
}

interface Props
{
    lang: Language;
    abbrs: Abbreviation[];
}